"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    /** Date Object */
    date: _propTypes.default.instanceOf(Date).isRequired,
    format: _propTypes.default.string,
    size: _propTypes.default.oneOf(_constant.ARR_FONT_SIZE),
    color: _propTypes.default.oneOf(_constant.ARR_COLORS),
    allowLocaleFormat: _propTypes.default.bool,
    locale: _propTypes.default.string,
    localeConfig: _propTypes.default.shape({
      month: _propTypes.default.string,
      day: _propTypes.default.string
    }),
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object
  },
  DefaultProps: {
    format: _constant2.DEFAULT_DATE_FORMAT,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    color: _constant.DEFAULT_COLOR,
    size: _constant.DEFAULT_FONT_SIZE,
    allowLocaleFormat: false,
    localeConfig: _constant2.LOCALE_CONFIG
  }
};
exports.default = _default;